// Styles
import styles from "../../../styles/Form.module.css"

export default function SystemFieldWarning({ label, warnTypeText }) {
  return (
    <div className={styles.field}>
      {label && (
        <label className={styles.label}>{label}</label>
      )}
      <p className={styles.sysFieldWarning}>System fields may not have their {warnTypeText} changed.</p>
    </div>
  )
}
